<template>
  <div>
    <b-navbar id="site-navbar" sticky class="header" type="dark" variant="primary">     
      <b-navbar-brand href="#">
        <img src="/logo_white.svg" class="logo">
        </img>
      </b-navbar-brand>
    </b-navbar>

    
    <b-row id="login-container">
      <b-col id="login" xl="6" offset-xl="3" md="8" offset-md="2"> 
        <div>
          <b-form class="form">  
            <h3 class="form-header bg-primary">
              Ellipse Configuration Tool
            </h3>

            <div class="form-content">

              <b-input-group class="pb-2">
                <b-input-group-prepend>
                  <div class="input-icon-prepend bg-primary">
                    <font-awesome-icon icon="user" transform="right-11 down-5"  :style="{ color: 'white' }" />
                  </div>
                </b-input-group-prepend>

                <b-form-input id="Username" type="text" @keyup.enter.native="authenticate" :state="success" v-model="auth.username" required placeholder="Enter username" @change.native="success = null;"/>
              </b-input-group>

              <b-input-group class="pb-3">
                <b-input-group-prepend>
                  <div class="input-icon-prepend bg-primary">
                    <font-awesome-icon icon="lock" transform="right-11 down-5"  :style="{ color: 'white' }" />
                  </div>
                </b-input-group-prepend>

                <b-form-input id="password" type="password" @keyup.enter.native="authenticate" :state="success" v-model="auth.password" required placeholder="Enter password" @change.native="success = null;" />
              </b-input-group>

              <b-alert variant="danger" :show="failure">Wrong username or password</b-alert>
              <b-alert variant="danger" :show="blocked">
                Your account has temporarily been blocked. <br/>
                You will be able to login in {{formatTimeStamp(blockedUntil)}} minutes.
              </b-alert>

              <b-alert :show="error !== undefined" variant="danger">{{error}}</b-alert>

              <b-button variant="primary" v-on:click="authenticate" block>
                <!--Login-->
                <font-awesome-icon icon="sign-in-alt" :style="{ color: 'white' }" />

                <icon name="spinner" spin v-if="pending"></icon>
              </b-button>
            </div>

          </b-form>
        </div>

        <div class="pt-3" style="text-align: center;">
          <b-link href="#" to="/reset">Forgot username or password?</b-link>

        </div>

        <p class="pt-5" id="footer_text" style="text-align: center;">
          <svg version="1.1" id="Layer_1" xmlns="&ns_svg;" xmlns:xlink="&ns_xlink;" width="21.56" height="14.02" viewBox="0 0 64.705 42.064" overflow="visible" enable-background="new 0 0 64.705 42.064" xml:space="preserve" style="padding-bottom: 2px">
            <g>
              <path d="M0,42.064L24.258,0l24.258,42.064H40.43L24.24,14.08L8.086,42.064H0z M16.172,42.064l10.793-18.686l4.043,7.014l-2.707,4.658h5.396l4.043,7.014H16.172z M33.68,11.707l6.75-11.672l24.275,42.029H51.223l-4.061-7.014h5.414L40.412,14.063l-2.672,4.658L33.68,11.707z"/>
            </g>
          </svg>
          <b>Logos Design A/S </b> | Nærum Hovedgade 6 | DK-2850 Nærum, Danmark | Tel +45 45 87 78 99
        </p>

      </b-col>
    </b-row>
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";

import axios from 'axios'
import moment from 'moment'

export default {
  data() {
    return {
      error: undefined,
      success: null,
      blocked: null,
      blockedUntil: undefined,
      auth: {
        username: undefined,
        password: undefined
      }
    }
  },

  computed: {
    isLoggedIn () {
      return this.$store.state.isLoggedIn
    },
    pending () {
      return this.$store.state.pending
    },
    failure(){
      if(this.success === null || this.success === undefined) return false;
      return !this.success;
    }
  },

  methods: {
    ...mapActions(['login']),
    _authenticate(){
    },
    authenticate(){
      this.success = null; // Reset
      this.blocked = null; // Reset
      this.blockedUntil = undefined;      

      axios.post("/api/v1/auth/login", {
        Username: this.auth.username,
        Password: this.auth.password
      })
      .then( res => {
        this.login(res.data.Token);
        this.$router.push({name:'systems'});
      })
      .catch( err => {
        console.error(err);
        if( err.response.data.Errors !== undefined && err.response.data.Errors[0] !== undefined && err.response.data.Errors[0].ErrorKey === 'login_attempts_exceeded'){
          this.blocked = true;
          this.blockedUntil = err.response.data.Errors[0].Message;
        }else{
          this.success = false;
        }
      })
    },
    formatTimeStamp(time){
      return moment(moment(time).diff(moment())).format('mm:ss');
    }
  }
};
</script>

<style scoped>
 .header {
    background-color: #000000 !important;
  }


  .logo {
    max-height: 60px;
    margin-bottom: -20px;
    margin-top: -20px;
    margin-left: -25px;
  }

  #login-container {
    margin: top 100px;
  }

  .form {
    margin-top: 100px;
    width: 100%;
    border-radius: 0 0 5px 5px;
    background-color: #E9E9E9;
    -webkit-box-shadow: px px 9px 0px rgba(50, 50, 50, 0.3);
    -moz-box-shadow: px px 9px 0px rgba(50, 50, 50, 0.3);
    box-shadow: px px 9px 0px rgba(50, 50, 50, 0.3);
  }

	#footer_text {
		font-size: 12px !important;
	}

  .form-content{
    padding: 20px 20px 20px 20px;
  }

  /* Override */
  h1 {
    margin: 0;
    font-size:30px;
    padding-top:20px;
  }
  @media (min-width: 992px) {
    h1 {
      font-size: 40px;
      padding-top:15px
    }
  }

  .form-header {
    font-weight: bold;
    font-family: 'Open Sans', sans-serif;
    text-transform: uppercase;
    color: white;
    text-align: center;
    border-radius: 5px 5px 0 0;
    -webkit-box-shadow: px px 9px 0px rgba(50, 50, 50, 0.3);
    -moz-box-shadow: px px 9px 0px rgba(50, 50, 50, 0.3);
    box-shadow: px px 9px 0px rgba(50, 50, 50, 0.3);
    vertical-align: middle;
    height: 75px;
    padding-top: 20px;
  }

  .input-icon-prepend {
    /*background-color: #3388CC;*/
    border-radius: .25rem 0 0 .25rem;
    width: 40px;
    border: 1px solid #ced4da;
  }

  .input-icon-prepend > * svg {
    left: 50%;
  }

  .pm-blue-button {
    background-color: #3388CC;
    border: 1px solid #ced4da;
  }
</style>


// WEBPACK FOOTER //
// WebApp/components/Login.vue